import { mockCall } from './mock'
const useMock = import.meta.env.VITE_USE_MOCK === 'true'
const endpoint = import.meta.env.VITE_ADMIN_API_URL || '/api/admin'
async function call(action, payload={}) {
  if (useMock) return mockCall(action, payload)
  const token = localStorage.getItem('adminToken') || ''
  const response = await fetch(endpoint, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, body:JSON.stringify({ action, ...payload }) })
  if (!response.ok) throw { code:'NETWORK_ERROR', message:`服务返回 ${response.status}` }
  const result = await response.json()
  if (!result.ok) { if (result.error?.code === 'AUTH_REQUIRED') { localStorage.removeItem('adminToken'); if (location.pathname !== '/login') location.href='/login' } throw result.error }
  return result.data
}
async function uploadMedia(file, usageKind='admin') {
  if (useMock) {
    const dataUrl = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload=()=>resolve(reader.result); reader.onerror=reject; reader.readAsDataURL(file) })
    const data = await mockCall('uploadBrandAsset', { dataUrl })
    return { fileId:data.fileId, url:data.fileId }
  }
  const form = new FormData(); form.append('file', file); form.append('usageKind', usageKind)
  const mediaEndpoint = endpoint.replace(/\/admin\/?$/, '/media/admin/upload')
  const response = await fetch(mediaEndpoint, { method:'POST', headers:{ Authorization:`Bearer ${localStorage.getItem('adminToken') || ''}` }, body:form })
  const result = await response.json()
  if (!response.ok || !result.ok) throw result.error || { code:'NETWORK_ERROR', message:`服务返回 ${response.status}` }
  return result.data
}
export default { call, uploadMedia, isMock: useMock }
